import { ActivityStatusEnum } from "../../enums/activity.enum";

export const InvoiceTypeOption = [
    { label: "Ready for Billing", value: ActivityStatusEnum.READY_FOR_BILLING},
    { label: "Invoice Generated", value: ActivityStatusEnum.INVOICE_GENERATED },
]